import React, { Component } from "react";
import Select from 'react-select';
import XLSX from 'xlsx';
import { make_cols } from './MakeColumns';
import { SheetJSFT } from './types.js';
import '../App.css'
import TopBar from "../components/TopBar";
import { createMuiTheme, MuiThemeProvider, Divider } from '@material-ui/core'

import { withStyles, } from "@material-ui/core";

import { Input } from '@material-ui/core'

import CardCompShows from "../components/Navigation/CardComponentShows";

import { AddShow, GetShows , seatSectionKeys ,seatSection } from "../services/userServices";

import { Button } from 'reactstrap';

const theme = createMuiTheme({
    overrides: {
        MuiChip: {
            root: {
                fontSize: "11px",
                color: "#3c4043",
                marginTop: 20,
                height: 25,
                backgroundColor: "rgba(0, 0, 0, 0.10)",
                padding: "3px 5px"
            },
            deleteIcon: {
                width: 14,
                height: 14,
                margin: 0
            },
            label: {
                color: "#3c4043",
                cursor: "pointer",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                fontSize: "11px",
                margin: "0 6px",
                padding: "1px",
                paddingLeft: 0,
                paddingRight: 0,
                marginRight: 0,
                fontWeight: 600
            }
        }
    },
    typography: {
        useNextVariants: true
    }
});



class ShowsPage extends Component {
    constructor() {
        super();
        this.state = {
            showName: '',
            // showFile: '',
            showFileName: '',

            showsData: {},

            DisplayShows: {},

            Add: false,
            file: {},
            data: [],
            GetMyOptions:[],
            value:'',
            SelectOptions:[],
            showSelectTag :false,
            cols: []
        }
        this.handleFile = this.handleFile.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    /******************************************************************************************************************** */
    slideCards = () => {
        try {
            this.setState({ slideCards: !this.state.slideCards });
        } catch (err) {
            console.log("error at slideCards in dashBoard");
        }
    };


    handleChange(e) {
        const files = e.target.files;
        if (files && files[0]) this.setState({ file: files[0] });
      };


      handleFile() {
        /* Boilerplate to set up FileReader */
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        
        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA : true });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws);
          /* Update state */
          this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {
            this.setState({
              showSelectTag:true,
             })
            let arr=[];
            let seatsSectionKeys=[];
            Object.keys(this.state.data[0]).forEach(function(element) {
              if(element !== 'time' && element.startsWith("_")!==true && element.length>4 !==true){
                arr.push({ label:element, value: element })
                seatsSectionKeys.push(element);
              }
            });
            this.setState({
              SelectOptions:arr.sort()
            })
            seatSectionKeys(seatsSectionKeys.sort()).then(res=>{
                alert("Success!!")
              })
            Array.prototype.forEach.call(this.state.data, key =>{
             console.log(key['101'], key.time)
          })
            console.log(JSON.stringify(this.state.data, null, 2));
            seatSection(this.state.data).then(res=>{
              console.log(res)
            })
          });
     
        };
     
        if (rABS) {
          reader.readAsBinaryString(this.state.file);
        } else {
          reader.readAsArrayBuffer(this.state.file);
        };
      }
    /**
     * @description:it handles the cards style
     */
    handleCardStyle = () => {
        try {
            this.setState({ cardStyles: !this.state.cardStyles });
        } catch (err) {
            console.log("error at handleCardStyle in dashBoard");
        }
    }

    /***************************************************************************************************************** */


    handleShowName = evt => {
        try {
            this.setState({
                showName: evt.target.value
            })
        } catch (err) {
            console.log('error at handling showName in ShowPage');

        }
    }

    // handleShowFile = evt => {
    //     try {
    //         this.setState({
    //             showFile: evt.target.value
    //         })
    //     } catch (err) {
    //         console.log("error at handling showFile in ShowPage");

    //     }
    // }


    removeMe = () => {
        this.setState({
            showFileName: ''
        })
        document.querySelector('img[id=abc]').src = "";
    }
    getName = evt => {
        if (document.querySelector('input[id=asset]') !== null && document.querySelector('input[id=asset]').files[0]) {
            this.setState({
                // showFileName: document.querySelector('input[id=asset]').files[0].name
                showFileName: evt.document.querySelector('input[id=asset]').files[0].name
            })
        }
    }


    /**************************************************************************************************************** */

    handleSubmit(event) {
        try {
            if ((this.state.showName &&  this.state.section) !== '') {

                const data = {
                    showName: this.state.showName,
                    section:this.state.value,
                }
                AddShow(data)
                    .then((response) => {
                        this.setState({
                            showsData: response
                        })
                        setTimeout(() => {
                            this.RedirectUser()
                        }, 500)
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
        } catch (err) {
            console.log("error at handleSubmit in ShowDataGeneration");

        }
    }

    RedirectUser = () => {
        // this.props.history.push('/ShowsPage')

        // componentDidMount() {
            GetShows()
                .then((response) => {
                    console.log("response", response);
                    this.setState({
                        DisplayShows: response
                    });
                    console.log("DisplayShows", this.state.DisplayShows);
                })
                .catch((error) => {
                    console.log(error);
                });
        // }




    }

    /*********************************************************************************************************************************** */


    componentDidMount() {
        GetShows()
            .then((response) => {
                console.log("response", response);
                this.setState({
                    DisplayShows: response
                });
                console.log("DisplayShows", this.state.DisplayShows);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    sendValue =(e) =>{
        this.setState({
            value:e.value
        })
    }
    /*********************************************************************************************************************************** */

    render() {



        const { classes } = this.props;
        const slidingCards = this.state.slideCards ? "afterSlide" : "beforeSlide";






        var arr = []
        var key;
        var data

        arr = Object.keys(this.state.DisplayShows).map((notes) => {
            key = notes;
            // this.state.DisplayShows[key].eventDate = this.GetFormattedDate(this.state.DisplayShows[key].eventDate);
            // this.state.DisplayShows[key].eventTime = this.getFormattedTime(this.state.DisplayShows[key].eventTime)

            data = this.state.DisplayShows[key]
            return (
                <CardCompShows Display={data}
                    noteKey={key}
                    view={this.state.click}
                    navigation={this.props.navigation}
                />
            )
        })

        return (
            <MuiThemeProvider theme={theme} location={this.props.location}>


                <div className={classes.root}>

                    <div className={slidingCards} id={slidingCards}>

                        <div>
                            <TopBar
                                slideCards={this.slideCards}
                                props={this.props}
                                notePropsToApp={this.handleCardStyle}
                                handleNavigation={this.handleNavigation}
                            />
                        </div>
                    </div>

                    <div style={{ margin: '6% 14%' }}>


                        <h4 style={{ textDecorationLine: 'underline' }}>Shows :</h4>



                        <section class="sectionClass">

                            <div class="container-fluid">
                                <div class="row sectRow">

                                    <div class="col-md-4 col-sm-12" style={{}} >

                                        <div className='labelDivLeft'>
                                            <label style={{ fontWeight: 'bold' }} >Show Name:</label>
                                        </div>

                                        <div className='labelDivLeft' >
                                            <label style={{ fontWeight: 'bold' }} > Upload Excel: </label>
                                        </div>

                                        <div className='labelDivLeft'  >
                                            <Button
                                                type="submit"
                                                onClick={(event) => this.handleSubmit(event, 1)}
                                                // style={{ visibility: this.state.Add ? 'hidden' : 'visible', marginLeft: '-9%' }}
                                                style={{ visibility: this.state.Add ? 'hidden' : 'visible' }}
                                                className="ButtonStyle"
                                            >  Save
                                            </Button>
                                        </div>




                                    </div>

                                    <div class="col-md-8 col-sm-12">

                                        <div className='labelDivRight'>
                                            <Input
                                                // disableUnderline={true}
                                                style={{}}
                                                value={this.state.showName}
                                                onChange={this.handleShowName}
                                            />
                                        </div>

                                        <div className='labelDivRight' >
                                        <div>
                                    <label for='file' className="MyButton" style={{}} onMouseLeave={this.getName}> choose File </label>
                                    <input type="file" style={{ visibility: 'hidden' }} id="file" accept={SheetJSFT} onChange={this.handleChange} />
                                    <br />
                                    <input type='submit' 
                                    value="Upload"
                                    style={{marginTop:'1%', marginLeft:'-25%'}}
                                    className="MyButton"
                                    onClick={this.handleFile} />
                                        <div style={{ visibility: this.state.showSelectTag ? 'visible': 'hidden' , 
                                         margin: '0 20px',
                                         display: 'inline-block', 
                                         position: 'relative',
                                         width: '100%',
                                         maxWidth: '150px',}}>
                                        <Select options={ this.state.SelectOptions } onChange={(e) => this.sendValue(e)}/>
                                        </div>
                                    </div> </div> 

                                    </div>

                                </div>

                            </div>

                        </section>

                        <Divider />


                        {/* <CardCompShows /> */}
                        <div style={{ display:'inline-flex' , flexDirection:'row', paddingRight:'40px' }}>
                            {arr}
                        </div>


                    </div>

                </div>

            </MuiThemeProvider>

        )
    }
}
export default withStyles({ withTheme: true })(ShowsPage);
